import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { AppointmentCustomerFormContainer } from '../../../../components/AppointmentCustomerForm/AppointmentCustomerFormContainer.js';
import { getBookAppointmentStore } from '../../data/book-appointment-store.js';
import { getBookAppointmentType } from '../../data/book-appointment-type.js';
import { MissingStoreIdError, AlternativeUrlStoreError, MissingTypeIdError, MissingTimeSlotStartError, MissingTimeSlotEndError, InvalidVirtualAppointmentError, StoreNotFoundError, TypeNotFoundError, TypeNotAvailableForStoreError, LinkedAppointmentTypeNotValidError } from '../../errors.js';
import useBookAppointmentStoreWithUrlParam from '../../hooks/use-book-appointment-store-with-url-param.js';
import useBookAppointmentTimeSlotWithUrlParam from '../../hooks/use-book-appointment-time-slot-with-url-param.js';
import useBookAppointmentTypeWithUrlParam from '../../hooks/use-book-appointment-type-with-url-param.js';
import { getFormattedParams, hasValidVirtualAppointmentParams, generateVirtualAppointmentStoreData, hasInvalidVirtualAppointmentParams, isAppointmentTypeValid } from '../../utils.js';

const WhoRoot = ()=>{
    /** Refetch store, appointment type and time slots if has different typeId, storeId, start, end in the url
   * and store code, type id and time slot in the context.
   * This can be possible when user use back and forth browser button to navigate between steps */ useBookAppointmentStoreWithUrlParam();
    useBookAppointmentTypeWithUrlParam();
    useBookAppointmentTimeSlotWithUrlParam();
    return /*#__PURE__*/ React.createElement(AppointmentCustomerFormContainer, null);
};
WhoRoot.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, params, locale) {
        var ref;
        const formattedParams = getFormattedParams(params);
        if (formattedParams.storeId === undefined) {
            throw MissingStoreIdError();
        }
        if ((ref = formattedParams.alternativeUrlStores) === null || ref === void 0 ? void 0 : ref.includes(formattedParams.storeId)) {
            throw AlternativeUrlStoreError();
        }
        if (formattedParams.typeId === undefined) {
            throw MissingTypeIdError();
        }
        if (formattedParams.start === undefined) {
            throw MissingTimeSlotStartError();
        }
        if (formattedParams.end === undefined) {
            throw MissingTimeSlotEndError();
        }
        let promises = [
            null,
            null
        ];
        if (hasValidVirtualAppointmentParams(formattedParams)) {
            const type = yield getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
            promises = [
                type ? generateVirtualAppointmentStoreData(formattedParams.virtualStoreCode, type) : null,
                type, 
            ];
        } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
            throw InvalidVirtualAppointmentError();
        } else {
            promises = [
                getBookAppointmentStore(apolloClient, formattedParams.storeId, locale, formattedParams.tryInStoreFlow),
                getBookAppointmentType(apolloClient, formattedParams.typeId, locale), 
            ];
        }
        const [store, type] = yield Promise.all(promises);
        if (!store) {
            throw StoreNotFoundError();
        } else if (!type) {
            throw TypeNotFoundError();
        } else if (type && !isAppointmentTypeValid({
            typeId: type === null || type === void 0 ? void 0 : type.id,
            store
        })) {
            throw TypeNotAvailableForStoreError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.linkedAppointmentTypeId) && !isAppointmentTypeValid({
            typeId: formattedParams.linkedAppointmentTypeId,
            store
        })) {
            throw LinkedAppointmentTypeNotValidError();
        }
        return Promise.resolve({
            store,
            type,
            timeSlot: {
                from: formattedParams.start,
                until: formattedParams.end
            }
        });
    });
    return function(apolloClient, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

export { WhoRoot as default };
//# sourceMappingURL=WhoRoot.js.map
